<template>
  <div :id="content.idHTML" class="mb-2 liste-choix" :class="jel_getClassObject(content)">
    <label :for="idChoix" class="mt-1">
      {{ content.libChoix }}
    </label>
    <ValidationProvider v-slot="validationContext" name="optionChoisi" rules="required" tag="div">
      <div class="d-flex position-relative">
        <input
          :id="idChoix"
          v-model="optionChoisi"
          :name="content.inputNameChoix ? content.inputNameChoix : ''"
          type="hidden"
        />
        <div v-click-outside="onClickOutside" class="multiselect">
          <div @click="montrerListeChoix()">
            <b-input
              v-if="content.activerRecherche === 'true'"
              v-model="rechercheChoix"
              inputmode="text"
              class="barre-recherche"
              :placeholder="contenuPlaceholder"
              autocomplete="off"
            />
            <div v-else class="multiselect__tags">
              <span
                :id="'placeholder-' + idChoix"
                :class="[optionChoisi ? 'multiselect__single' : 'multiselect__placeholder']"
              >
                {{ contenu }}
              </span>
            </div>
          </div>
          <div
            v-show="afficherListeChoix && (!$isMobile() || content.utiliserModaleMobile !== 'true')"
            class="multiselect__content-wrapper"
          >
            <ul class="multiselect__content">
              <li
                v-if="listeChoix.length === 0 || listeChoixFiltrer.length === 0"
                @click="setInputValue()"
              >
                <span class="multiselect__option aucun-choix">
                  {{
                    listeChoix.length === 0
                      ? content.libListeVide
                      : $i18n.tc('messageComponent.aucunResultat')
                  }}
                </span>
              </li>
              <li
                v-for="(choix, index) in listeChoixFiltrer"
                v-else
                :key="index"
                class="multiselect__element"
                @click="setInputValue(choix)"
              >
                <span
                  class="multiselect__option"
                  :class="[
                    {
                      'multiselect__option--selected': optionChoisi === choix.value,
                    },
                  ]"
                >
                  {{ choix.option }}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div
          v-if="content.activerRecherche === 'true'"
          class="position-icone"
          @click="effacerChampProfession()"
        >
          <svg-icon v-if="optionChoisi" icon-name="icone-fermer" fill="$couleur-primaire" />
          <svg-icon v-else icon-name="icone-search" fill="$couleur-primaire" />
        </div>
        <div v-else class="position-icone" @click="montrerListeChoix()">
          <svg-icon
            :id="iconeFlecheId"
            :class="{ rotation180: afficherListeChoix }"
            icon-name="fleche-bas"
          />
        </div>
        <b-modal
          v-if="isAffichageModale"
          id="situation"
          v-model="afficherModale"
          size="mobile"
          hide-footer
          body-class="px-0 pt-0 p-sm-2 pb-sm-7 pb-4"
          content-class="p-sm-2"
        >
          <div slot="modal-header" class="modale-header division-colonne">
            <div class="division-ligne">
              <div class="col-3 px-0">
                <button class="modale-btn-annuler text-left" block @click="fermerModale">
                  {{ $t('annuler') }}
                </button>
              </div>
              <div class="col-7 text-center pr-4">
                <label class="entete pl-1">{{ content.libChoix }}</label>
              </div>
              <div class="col-2 text-right px-0">
                <button
                  class="modale-btn-confirmer px-0"
                  block
                  :class="{ 'opacity-50': !choixModale }"
                  :disabled="!choixModale"
                  @click="soumettreModale()"
                >
                  {{ $t('ok') }}
                </button>
              </div>
            </div>
            <!-- Section recherche -->
            <div v-if="content.activerRecherche === 'true'" class="division-ligne has-float-label">
              <b-input
                v-model="rechercheChoixMobile"
                inputmode="text"
                class="barre-recherche barre-recherche-mobile"
                :placeholder="content.placeholderSelection"
                autocomplete="off"
              />
              <label :for="content.libProfession">{{ content.placeholderSelection }}</label>
              <svg-icon
                class="icone-recherche-mobile"
                icon-name="icone-search"
                color="$couleur-primaire"
              />
            </div>
          </div>
          <div class="border-top border-bottom">
            <div class="list-group px-2">
              <button
                v-if="listeChoix.length === 0 || listeChoixFiltrer.length === 0"
                class="item-liste item-liste-non-selectionnable"
                @click="setInputValue()"
              >
                {{
                  listeChoix.length === 0
                    ? content.libListeVide
                    : $i18n.tc('messageComponent.aucunResultat')
                }}
              </button>
              <button
                v-for="(choix, index) in listeChoixFiltrer"
                v-else
                :key="index"
                squared
                class="item-liste item-liste-selectionnable"
                :class="{
                  'selected-list-element': choixModale
                    ? choixModale === choix
                    : choix.value == optionChoisi,
                }"
                @click="choixModale = choix"
              >
                {{ choix.option }}
              </button>
            </div>
          </div>
        </b-modal>
      </div>
      <ErreurValidation
        id="option-live-feedback"
        :message="validationContext.errors[0]"
      ></ErreurValidation>
    </ValidationProvider>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';
import ErreurValidation from '@/components/formulaire/compte/ErreurValidation';
import { normalize } from '@/helpers/StringHelpers';

export default {
  name: 'ListeChoix',
  components: {
    ErreurValidation,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: ['content', 'value'],
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          aucunResultat: 'Aucun résultat',
        },
      },
      en: {
        messageComponent: {
          aucunResultat: 'No results',
        },
      },
    },
  },
  data() {
    return {
      afficherListeChoix: false,
      afficherModale: false,
      choixModale: null,
      iconeFlecheId: `icone-fleche-${this.uid}`,
      idChoix: this._uid,
      inputElement: null,
      rechercheChoix: '',
      rechercheChoixMobile: '',
      listeChoix: [],
      valeurChoix: '',
    };
  },
  computed: {
    optionChoisi: {
      get() {
        return this.valeurChoix;
      },
      set(value) {
        if (value == null) {
          this.valeurChoix = value;
        } else {
          if (typeof value === 'string' && this.valeurChoix != value) {
            this.valeurChoix = value;
            this.$emit('input', value);
          }
          if (typeof value === 'object') {
            this.valeurChoix = value.value;
          }
        }
      },
    },

    listeChoixFiltrer() {
      return this.listeChoix
        .filter((choix) => {
          if (this.isAffichageModale) {
            return normalize(choix.option).indexOf(normalize(this.rechercheChoixMobile)) != -1;
          }
          return normalize(choix.option).indexOf(normalize(this.rechercheChoix)) != -1;
        })
        .sort((a, b) => a.option.localeCompare(b.option));
    },
    contenuPlaceholder() {
      return this.content.placeholderSelection;
    },
    contenu() {
      // doit conserver option même si non utilisé sinon value = undefined
      return this.optionChoisi
        ? Object.entries(this.listeChoix)
            .map(([option, value]) => {
              return { option: value.option, value: value.value };
            })
            .find((item) => item.value === this.optionChoisi).option
        : this.content.placeholderSelection;
    },
    isAffichageModale() {
      return this.content.utiliserModaleMobile === 'true' && this.$isMobile();
    },
  },
  created() {
    this.listeChoix = this.getListeChoix();
    if (this.content.optionChoisie) {
      if (this.content.optionChoisie != null && typeof this.content.optionChoisie === 'object') {
        this.setInputValue(this.content.optionChoisie);
      } else if (typeof this.content.optionChoisie === 'string') {
        this.optionChoisi = this.content.optionChoisie;
      }
    } else {
      this.optionChoisi = null;
    }
  },
  mounted() {
    this.inputElement = document.getElementById(this.idChoix);
  },
  updated() {
    this.listeChoix = this.getListeChoix();
    if (this.content.optionChoisie) {
      if (this.content.optionChoisie != null && typeof this.content.optionChoisie === 'object') {
        this.setInputValue(this.content.optionChoisie);
      } else if (typeof this.content.optionChoisie === 'string') {
        this.optionChoisi = this.content.optionChoisie;
      }
    } else {
      this.optionChoisi = null;
    }
  },

  methods: {
    // forcer la fermeture si le clic n'est pas l'input ou l'icône
    onClickOutside(event) {
      if (
        event.target.classList &&
        !event.target.classList.contains('multiselect__option') &&
        event.target.getAttribute('id') !== this.iconeFlecheId &&
        event.target.parentElement &&
        event.target.parentElement.getAttribute('id') !== this.iconeFlecheId
      ) {
        this.afficherListeChoix = false;
      }
    },
    // Attribuer la valeur de l'option choisie au input de donnée
    setInputValue(choix = null) {
      this.afficherListeChoix = false;
      this.optionChoisi = choix?.value;
      if (this.content.activerRecherche === 'true') {
        this.rechercheChoix = choix?.option;
      }
      this.inputElement = document.getElementById(this.idChoix);
      if (this.inputElement) {
        if (choix) {
          this.inputElement.setAttribute('value', choix.value);
          this.inputElement.checked = true;
        } else {
          this.inputElement.removeAttribute('value');
          this.inputElement.checked = false;
        }
      }
    },

    getListeChoix() {
      const listeChoix = [];
      const options = this.content.listeChoix;
      if (options) {
        let i = 0;
        // options[i] nécessaire pour gérer les liste de choix déjà traitées
        // les listes déjà traitées ne sont pas sous le format listeChoix0, listeChoix1, etc. mais sous le format 0, 1, etc.
        while (options[`listeChoix${i}`] != null || options[i]) {
          const uneOption = options[`listeChoix${i}`] || options[i];
          listeChoix.push({ option: uneOption.option, value: uneOption.value });
          i++;
        }
      }
      return listeChoix;
    },

    // Afficher la bonne interface de liste de choix selon si on est en mode recherche ou pas
    montrerListeChoix() {
      this.afficherListeChoix = true;
      if (this.isAffichageModale) {
        this.montrerModale();
      }
    },
    soumettreModale() {
      this.afficherModale = false;
      this.setInputValue(this.choixModale);
      this.fermerModale();
    },
    montrerModale() {
      this.afficherModale = true;
      this.rechercheChoixMobile = '';
      document.querySelectorAll('.multiselect')[0].focus();
    },
    fermerModale() {
      this.afficherModale = false;
      this.afficherListeChoix = false;
      this.choixModale = null;
      this.rechercheChoixMobile = '';
    },

    // DÉBUT GESTION AFFICHAGE RECHERCHE
    effacerChampProfession() {
      this.optionChoisi = '';
      this.rechercheChoix = '';
    },
    // FIN GESTION AFFICHAGE RECHERCHE
  },
};
</script>

<style lang="scss">
.multiselect {
  cursor: pointer;
}
.multiselect__option:not(.aucun-choix):hover {
  background-color: $couleur-secondaire;
}
select {
  appearance: none;
}
.position-icone {
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  right: 0.7rem;
  cursor: pointer;
}
.opacity-50 {
  opacity: 0.5;
}
.entete {
  flex-grow: 1;
  padding-top: 0.05rem;
  text-align: center;
  color: $couleur-texte-primaire-focus;
  font-family: graphik_bold;
  line-height: 20px;
}
.liste-choix {
  .modal-dialog {
    display: flex;
    justify-content: center;
  }

  .modal-content {
    max-height: 90%;
    margin: auto;
  }
}

.modale-btn-annuler {
  width: 5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
  border: none;
  color: $couleur-primaire;
  background-color: inherit;
  text-decoration: none;
  font-weight: bold;
}
.modale-btn-annuler:focus {
  background: inherit;
  font-weight: bold;
  color: $couleur-primaire;
  border-bottom: 1px solid $couleur-secondaire;
}

.modale-btn-confirmer {
  width: auto;
  height: 1.5rem;
  text-align: center;
  border: none;
  color: $couleur-primaire;
  background-color: inherit;
  font-weight: bold;
  text-decoration: none;
  border-bottom: 1px solid $couleur-secondaire;
}
.modale-btn-confirmer:focus {
  background: inherit;
  background-color: $couleur-secondaire;
  color: $couleur-primaire;
  border: none;
  outline: none;
}

.division-colonne {
  width: 100%;
  position: relative;
  display: grid;
}
.division-ligne {
  width: 100%;
  position: relative;
  display: flex;
}

.item-liste {
  color: $couleur-primaire;
  width: 100%;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  font-family: 'Graphik', Graphik, sans-serif;
  background: inherit;
  text-align: left;
  outline: 0;
}
.item-liste-non-selectionnable {
  border: none;
}
.item-liste-selectionnable {
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-width: thin;
  border-color: lightgray;
}
.item-liste-selectionnable:focus {
  background-color: $couleur-secondaire;
  font-weight: bold;
  color: $couleur-texte-primaire-focus;
  font-family: 'Graphik', Graphik, sans-serif;
  border: none;
  outline: 0;
}
.item-liste-selectionnable:first-child {
  border: none !important;
}
.icone-recherche-mobile {
  height: 1.5rem;
  position: absolute;
  margin-left: 0.7rem;
  margin-top: 0.75rem;
  color: $couleur-primaire;
}

.textePlaceholder {
  //couleur #5c636a format RGB pour ajouter opacité seulement au texte
  color: rgba(92, 99, 106, 0.5) !important;
}

.form-control {
  padding-left: 0.75rem;
  position: relative;
  display: inline-block;
  background-color: $couleur-fond-primaire !important;
  width: 100%;
  color: $couleur-primaire;
  font-weight: normal;
  font-size: 18px;
  line-height: 20px;
  font-family: 'Graphik', Graphik, sans-serif;
}
.form-control:focus {
  box-shadow: none !important;
}
.form-control::placeholder {
  color: $couleur-primaire;
  opacity: 0.5;
}
.has-float-label .form-control:placeholder-shown:not(:focus) + label {
  font-size: 18px;
  padding: 0.1rem;
  padding-left: 1.3rem;
  background: transparent;
  pointer-events: none;
  z-index: 0;
}

.selected-list-element {
  font-weight: 700;
  background-color: $couleur-secondaire;
}

.barre-recherche {
  position: relative;
  display: inline-block;
  background-color: $couleur-fond-primaire !important;
  width: 100%;
  color: $couleur-primaire;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  font-family: 'Graphik', Graphik, sans-serif;
  &.barre-recherche-mobile {
    padding-left: 2rem !important;
  }
}
</style>
